import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import base64 from "base-64";
import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import { connect } from "react-redux";
import { getOrderDetailWithLinesByOrderIdRequest } from "store/actions";
import OrderDetailList from "./OrderDetailList";
import OrderDetailModal from "./OrderDetailModal";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import orderDetailReducer from "store/OrderDetail/reducer";
import orderDetailSaga from "store/OrderDetail/saga";
import OrderReviewForm from "./OrderReviewForm";
import { renderToStaticMarkup } from "react-dom/server";
import Invoice1 from "app/SampleInvoices/Invoice1";
import easyinvoice from "easyinvoice";

const orderDetailKey = "OrderDetail";

const withOrderDetailReducer = injectReducer({
  key: orderDetailKey,
  reducer: orderDetailReducer,
});
const withOrderDetailSaga = injectSaga({
  key: orderDetailKey,
  saga: orderDetailSaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDialog: false,
      feedbackForm: false,
      orderDetailData: null,
      downloadLoading: false,
    };

    this.validator = new SimpleReactValidator();
  }

  handleOnViewOrder = (orderDetailData) => {
    this.setState({
      orderDialog: true,
      orderDetailData,
    });
  };

  closeModal = () => {
    this.setState({
      orderDialog: false,
      orderDetailData: null,
    });
  };

  clickFeedbackHandler = (orderRecord) => {
    this.setState({
      feedbackForm: true,
      orderDetailData: orderRecord,
    });
  };

  onCloseModal = () => {
    this.setState({
      feedbackForm: false,
      orderDetailData: null,
    });
  };

  handleDownloadInvoice = (order) => {
    if (order?.orderDetailId && !this.state.downloadLoading) {
      this.setState({
        downloadLoading: true,
      });
      this.props.getOrderDetailWithLinesByOrderIdRequest(
        order.orderDetailId,
        async (response) => {
          if (response.isSuccessResponse) {
            const data = {
              customize: {
                template: base64.encode(
                  unescape(
                    encodeURIComponent(
                      renderToStaticMarkup(
                        <Invoice1 data={response.responseData} />
                      )
                    )
                  )
                ),
              },
              images: {
                logo: "https://admin.mangaldeepfamilyshop.in/logo.png",
              },
              settings: {
                "margin-top": 5,
                "margin-left": 5,
                "margin-right": 5,
                "margin-bottom": 5,
              },
            };
            const result = await easyinvoice.createInvoice(data);
            easyinvoice.download(`${order.orderNo}.pdf`, result.pdf);
            this.setState({
              downloadLoading: false,
            });
          } else {
            this.setState({
              downloadLoading: false,
            });
          }
        }
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          {this.state.orderDialog && (
            <OrderDetailModal
              orderDialog={this.state.orderDialog}
              closeModal={this.closeModal}
              orderDetailData={this.state.orderDetailData}
            />
          )}
          {this.state.feedbackForm && (
            <OrderReviewForm
              orderRecord={this.state.orderDetailData}
              formDialog={this.state.feedbackForm}
              closeModal={this.onCloseModal}
            />
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Order</h4>
                  </div>
                  <OrderDetailList
                    onViewOrder={this.handleOnViewOrder}
                    onFeedbackView={this.clickFeedbackHandler}
                    onDownloadInvoice={this.handleDownloadInvoice}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const withConnect = connect(null, {
  getOrderDetailWithLinesByOrderIdRequest,
});

export default compose(
  withOrderDetailReducer,
  withOrderDetailSaga,
  withConnect,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
